import { render, staticRenderFns } from "./subBtnBox.vue?vue&type=template&id=28c869e8&scoped=true&"
import script from "./subBtnBox.vue?vue&type=script&lang=js&"
export * from "./subBtnBox.vue?vue&type=script&lang=js&"
import style0 from "./subBtnBox.vue?vue&type=style&index=0&id=28c869e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c869e8",
  null
  
)

export default component.exports